// Project imports
import * as types from './actionTypes';
import axios from 'axios';
import * as urls from './urlTypes';
import { toastError } from '../util/toastUtils';

export const registerUser = async user => {
  let url = `${urls.API_GATEWAY_URL}/registration`;
  let method = 'post';
  try {
    const response = await axios({
      url,
      method,
      data: user,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response) {
      return {
        error: error.response.data.message,
      };
    }
    toastError('Api failed to Register the user');
    return false;
  }
};
